import React, { Dispatch, SetStateAction } from "react";

import { useAnalytics } from "@accurx/analytics";
import { Ds } from "@accurx/design";

import { StyledOrganisationName } from "../../MapWorkspacePage.styles";
import {
    UserSelectedOrganisation,
    UserTypedOrganisation,
} from "../../MapWorkspacePage.types";

export const MapWorkspaceConfirmModal = ({
    modalOpen,
    setModalOpen,
    organisation,
    submitCallback,
    workspaceName,
}: {
    modalOpen: boolean;
    setModalOpen: Dispatch<SetStateAction<boolean>>;
    organisation: UserSelectedOrganisation | UserTypedOrganisation;
    submitCallback: () => void;
    workspaceName: string;
}) => {
    const track = useAnalytics();

    const onSubmit = () => {
        track(
            "WorkspaceNationalCodeMappingOrganisationSubmit Button Click",
            {},
        );
        submitCallback();
    };

    const onChange = () => {
        track(
            "WorkspaceNationalCodeMappingOrganisationChange Button Click",
            {},
        );
        setModalOpen(false);
    };

    return (
        <Ds.Modal
            open={modalOpen}
            onOpenChange={setModalOpen}
            dismissible={false}
            data-testid="select-organisation-confirmation-modal"
        >
            <Ds.Modal.Section>
                <Ds.Flex flexDirection="column" gap="2">
                    <Ds.Flex justifyContent="space-between" gap="2">
                        <Ds.Modal.Title>Submit organisation</Ds.Modal.Title>
                    </Ds.Flex>
                    <Ds.Text weight="bold">Organisation selected:</Ds.Text>
                    <StyledOrganisationName>
                        {organisation.organisationName}
                    </StyledOrganisationName>
                    <Ds.Text color="metal">
                        We'll review your answer and then link{" "}
                        <strong>{workspaceName}</strong> to{" "}
                        {organisation.organisationName}. We'll contact you if
                        there are any issues.
                    </Ds.Text>
                    <Ds.Flex gap="2" justifyContent="flex-end">
                        <Ds.Button appearance="secondary" onClick={onChange}>
                            Change organisation
                        </Ds.Button>

                        <Ds.Button onClick={onSubmit}>
                            Confirm submission
                        </Ds.Button>
                    </Ds.Flex>
                </Ds.Flex>
            </Ds.Modal.Section>
        </Ds.Modal>
    );
};
